import { Carrier, Port, Route } from './../';
import { Trip } from './trip';

export class Trips {

  public searchId: string;
  public total: number;

  public message: string;
  public subject: string;

  public carriers: Array<Carrier>;
  public items: Array<Trip>;

  public destinationPorts: Array<{ count: number, selected: boolean, port: Port }>;
  public originPorts: Array<{ count: number, selected: boolean, port: Port }>;

  public selectedCarriers: Array<number>;
  public excludedCarriers: Array<number>;
  public selectedDestinationPorts: Array<number>;
  public selectedOriginPorts: Array<number>;

  public maxDuration: number;
  public selectedMaxDuration: number;
  public minDuration: number;
  public selectedMinDuration: number;

  public transhipments: Array<{ amount: number, selected: boolean }>;
  public selectedTranshipments: Array<number>;

  public routes: Array<Route>;

  public originBounds: {
    north: number,
    east: number,
    south: number,
    west: number
  };
  public destinationBounds: {
    north: number,
    east: number,
    south: number,
    west: number
  };

  constructor(json: any) {
    try {
      let summary = json.data.summary;
      let data = json.data;

      this.searchId = data.searchId;
      this.total = summary.count;

      this.maxDuration = summary.max_duration || 0;
      this.minDuration = summary.min_duration || 0;
      this.selectedMaxDuration = summary['selected_duration.lte'] || this.maxDuration;
      this.selectedMinDuration = summary['selected_duration.gte'] || this.minDuration;

      this.setMapBounds(summary);
      this.setItems(data.items);
      this.setDestinationPorts(summary);
      this.setOriginPorts(summary);
      this.setCarriers(summary);
      this.setTranshipments(summary);
    } catch (ex) {
      this.setDefaults();
    }
  }

  setDefaults() {
    this.searchId = '';
    this.total = 0;
    this.maxDuration = 0;
    this.minDuration = 0;
    this.selectedMaxDuration = 0;
    this.selectedMinDuration = 0;

    this.originBounds = {
      north: 45, east: 45, south: -45, west: -45
    };
    this.destinationBounds = {
      north: 45, east: 45, south: 45, west: 45
    };
    this.items = [];
    this.destinationPorts = [];
    this.selectedDestinationPorts = [];
    this.originPorts = [];
    this.selectedOriginPorts = [];
    this.carriers = [];
    this.selectedCarriers = [];
    this.excludedCarriers = [];
    this.transhipments = [];
    this.selectedTranshipments = [];
  }

  setMapBounds(summary: any) {
    try {
      this.originBounds = {
        north: summary.available_origin_ports[0].port.latlong[0] + 1,
        east: summary.available_origin_ports[0].port.latlong[1] + 1,
        south: summary.available_origin_ports[0].port.latlong[0] - 1,
        west: summary.available_origin_ports[0].port.latlong[1] - 1
      };
    } catch (ex) {
      this.originBounds = {
        north: 45, east: 45, south: -45, west: -45
      };
    }

    try {
      this.destinationBounds = {
        north: summary.available_destination_ports[0].port.latlong[0] + 1,
        east: summary.available_destination_ports[0].port.latlong[1] + 1,
        south: summary.available_destination_ports[0].port.latlong[0] - 1,
        west: summary.available_destination_ports[0].port.latlong[1] - 1
      };
    } catch (ex) {
      this.destinationBounds = {
        north: 45, east: 45, south: -45, west: -45
      };
    }
  }

  setItems(items: Array<any>) {
    this.items = [];
    try {
      for (let current = 0; current < items.length; current++) {
        this.items.push(new Trip(items[current]));
      }
    } catch (ex) {
    }
  }

  setDestinationPorts(summary: any) {
    this.destinationPorts = [];
    this.selectedDestinationPorts = [];
    let available = summary.available_destination_ports;

    for (let current = 0; current < available.length; current++) {
      let port = new Port(available[current].port);
      let count = available[current].count;

      this.destinationPorts.push({ count: count, selected: true, port: port });

      this.selectedDestinationPorts.push(port.id);

      let lat = port.latlong[0];
      let lng = port.latlong[1];

      if (port.latlong[0] !== null && port.latlong[1] !== null) {
        this.destinationBounds.north = Math.max(lat, this.destinationBounds.north);
        this.destinationBounds.east = Math.max(lng, this.destinationBounds.east);
        this.destinationBounds.south = Math.min(lat, this.destinationBounds.south);
        this.destinationBounds.west = Math.min(lng, this.destinationBounds.west);
      }
    }
  }

  setOriginPorts(summary) {
    this.originPorts = [];
    this.selectedOriginPorts = [];
    let available = summary.available_origin_ports;

    for (let current = 0; current < available.length; current++) {
      let port = new Port(available[current].port);
      let count = available[current].count;

      this.originPorts.push({ count: count, selected: true, port: port });

      this.selectedOriginPorts.push(port.id);

      let lat = port.latlong[0];
      let lng = port.latlong[1];

      if (port.latlong[0] !== null && port.latlong[1] !== null) {
        this.originBounds.north = Math.max(lat, this.originBounds.north);
        this.originBounds.east = Math.max(lng, this.originBounds.east);
        this.originBounds.south = Math.min(lat, this.originBounds.south);
        this.originBounds.west = Math.min(lng, this.originBounds.west);
      }
    }
  }

  setCarriers(summary: any) {
    this.carriers = [];
    this.selectedCarriers = summary.selected_carriers;
    this.excludedCarriers = summary.excluded_carriers;

    let available = summary.available_carriers;
    let selected = summary.selected_carriers;
    let excluded = summary.excluded_carriers;

    for (let current = 0; current < available.length; current++) {
      let carrier = new Carrier(available[current].carrier);

      carrier.setSummary(available[current], this.isCarrierSelected(carrier.id, selected, excluded));

      this.carriers.push(carrier);
    }
  }

  isCarrierSelected(carrierId: Number, selected: Array<Number>, excluded: Array<Number>): boolean {
    if (selected.length === 0 && excluded.length === 0) {
      return true;
    }

    // excluded
    if (excluded.indexOf(carrierId) > -1) {
      return false;
    }

    // selected and not excluded
    if (selected.indexOf(carrierId) > -1) {
      return true;
    }

    // not selected
    if (selected.length !== 0) {
      return false;
    }

    // not excluded
    return true;
  }

  setTranshipments(summary: any) {
    this.transhipments = [];
    this.selectedTranshipments = [];
    let available = summary.available_transhipments;
    let selected = summary.selected_transhipments;
    let allTranshipmentsSelected = selected.length === 0 ? true : false;

    for (let current = 0; current < available.length; current++) {
      let total = available[current] || 0; // number of transhipments
      let isSelected = selected.indexOf(total) > -1 || allTranshipmentsSelected;

      if (selected.indexOf(total) > -1 && !allTranshipmentsSelected) {
        this.selectedTranshipments.push(total);
      }

      this.transhipments.push({ amount: total, selected: isSelected });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/trip-models/trips.ts